var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export let activeFetchMethod = (inputs) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(inputs.url, inputs.init);
    if (!response.ok) {
        let message = "";
        try {
            message = yield response.text();
        }
        catch (e) {
            // Do nothing
        }
        throw new Error(`Error while fetching ${inputs.url}. Response status ${response.status}. ${message}`);
    }
    const value = yield inputs.responseResolver(response);
    return value;
});
export function setFetchMethod(fetchMethod) {
    activeFetchMethod = fetchMethod;
}
//# sourceMappingURL=fetchMethod.js.map